import {
  media,
  T4, T4Props,
} from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledButton = styled.button <{ allNews: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 32px 32px;
  padding-bottom: 32px;
  border-radius: 4px;
  border: inherit;
  display: flex;
  background-color: ${({ theme }) => theme.colors.blue12}; 
  text-align: inherit;
  outline: none;

  &:focus {
    background-color: ${({ theme }) => theme.colors.blue14};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue14};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.blue15};
  }

  ${({ allNews, theme }) => allNews && `
    background-color: ${theme.colors.white};
    box-shadow: ${theme.boxShadows.medium};
    &:hover {
     background-color: ${theme.colors.blue12};
    }
    &:active {
     background-color: ${theme.colors.blue14};
    }
    padding-bottom: 21px;
  `}

  ${media.lg <{ allNews: boolean }>`
    margin-bottom: 0px;
    margin-right: 0px;
    ${({ allNews }) => allNews && `
    margin-bottom: 12px;
  `}
  `}
`;

export const StyledT = styled<FC<T4Props>>(T4)`
  color: ${({ theme }) => theme.colors.blue5};
  line-height: 22px;
  margin-bottom: 12px;
  // Limit number of lines 
  display: -webkit-box;  
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const StyledTime = styled.div`
font-size: 14px;
line-height: 18px;
`;

export const StyledDiv = styled.div`
  display: inline-grid;
`;
